function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FF8767",
  d: "M13.909.1c17.155-.72 27.708 4.371 32.687 14.525C51.575 24.779 41.758 43.107 32 46.7c-9.758 3.593-24.945-.721-29.1-12.2C-1.255 23.021-3.246.82 13.909.1z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1B1B1B",
  fillRule: "nonzero",
  d: "M20.32 36v-9.888h5.088c4 0 7.104-3.008 7.104-6.976 0-3.936-3.104-7.136-7.104-7.136h-9.92v24h4.832zm4.64-13.824h-4.64v-5.984h4.64c1.76 0 3.168 1.216 3.168 2.976 0 1.824-1.408 3.008-3.168 3.008z"
});

function SvgFavicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iI0ZGODc2NyIgZD0iTTEzLjkwOS4xYzE3LjE1NS0uNzIgMjcuNzA4IDQuMzcxIDMyLjY4NyAxNC41MjVDNTEuNTc1IDI0Ljc3OSA0MS43NTggNDMuMTA3IDMyIDQ2LjdjLTkuNzU4IDMuNTkzLTI0Ljk0NS0uNzIxLTI5LjEtMTIuMkMtMS4yNTUgMjMuMDIxLTMuMjQ2LjgyIDEzLjkwOS4xeiIvPjxwYXRoIGZpbGw9IiMxQjFCMUIiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTIwLjMyIDM2di05Ljg4OGg1LjA4OGM0IDAgNy4xMDQtMy4wMDggNy4xMDQtNi45NzYgMC0zLjkzNi0zLjEwNC03LjEzNi03LjEwNC03LjEzNmgtOS45MnYyNGg0LjgzMnptNC42NC0xMy44MjRoLTQuNjR2LTUuOTg0aDQuNjRjMS43NiAwIDMuMTY4IDEuMjE2IDMuMTY4IDIuOTc2IDAgMS44MjQtMS40MDggMy4wMDgtMy4xNjggMy4wMDh6Ii8+PC9zdmc+";
export { SvgFavicon as ReactComponent };